"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = ({
  size = 24,
  width = size,
  height = size,
  ...restProps
}) => /*#__PURE__*/_react.default.createElement("svg", _extends({
  width: width,
  height: height,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, restProps), /*#__PURE__*/_react.default.createElement("ellipse", {
  rx: "1.7138",
  ry: "1.64206",
  transform: "matrix(1.00425 1.59474e-07 0.00737265 0.995702 11.6175 11.9004)",
  fill: "white"
}), /*#__PURE__*/_react.default.createElement("ellipse", {
  rx: "1.7138",
  ry: "1.64206",
  transform: "matrix(1.00425 1.59474e-07 0.00737265 0.995702 19.2669 11.9004)",
  fill: "white"
}), /*#__PURE__*/_react.default.createElement("ellipse", {
  rx: "1.7138",
  ry: "1.64206",
  transform: "matrix(1.00425 0 0.00737247 0.995702 8.17509 15.1691)",
  fill: "white"
}), /*#__PURE__*/_react.default.createElement("ellipse", {
  rx: "1.7138",
  ry: "1.64206",
  transform: "matrix(1.00425 0 0.00737247 0.995702 15.8245 15.1691)",
  fill: "white"
}), /*#__PURE__*/_react.default.createElement("ellipse", {
  rx: "1.7138",
  ry: "1.64206",
  transform: "matrix(1.00425 0 0.00737247 0.995702 4.7332 18.8039)",
  fill: "white"
}), /*#__PURE__*/_react.default.createElement("ellipse", {
  rx: "1.7138",
  ry: "1.64206",
  transform: "matrix(1.00425 0 0.00737247 0.995702 12.3826 18.8039)",
  fill: "white"
}), /*#__PURE__*/_react.default.createElement("ellipse", {
  rx: "1.7138",
  ry: "1.64206",
  transform: "matrix(1.00425 -7.9395e-08 0.00737238 0.995702 8.17509 8.26696)",
  fill: "white"
}), /*#__PURE__*/_react.default.createElement("ellipse", {
  rx: "1.7138",
  ry: "1.64206",
  transform: "matrix(1.00425 -7.9395e-08 0.00737238 0.995702 15.8245 8.26696)",
  fill: "white"
}), /*#__PURE__*/_react.default.createElement("ellipse", {
  rx: "1.7138",
  ry: "1.64206",
  transform: "matrix(1.00425 8.42937e-08 0.00700395 0.995705 4.73259 4.635)",
  fill: "white"
}), /*#__PURE__*/_react.default.createElement("ellipse", {
  rx: "1.7138",
  ry: "1.64206",
  transform: "matrix(1.00425 8.42937e-08 0.00700395 0.995705 12.3819 4.635)",
  fill: "white"
}));

exports.default = _default;